(function () {
    angular.module('tmx-app').factory('CallingReportService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportCallingReport = exportCallingReport;
            function exportCallingReport(userid,fromdate,todate) {

                if(!userid){
                    userid=null;
                }
                
                if(!fromdate){
                    fromdate=null;
                }

                if(!todate){
                    todate=null;
                }

                var objArgs = {
                    "UserId":userid,
                    "FromDate":fromdate,
                    "ToDate":todate
                };

                var filters = {
                    "StoredProcedure": "sp_calling_report",
                    "Arguments": objArgs,
                    "ReportName": "Calling_Report",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'CallingSheet.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: "ProductName",
                    title: "Product",
                    type: "text",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('ProductName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Product</span>"
                },
                {
                    field: "LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('LoanApplicationNumber')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Loan Application Number</span>"
                },
                {
                    title: "Residence",
                    width: $mdMedia('gt-sm') ? '30%' : '150px',
                    headerAttributes: {
                        "class": "merge-grid-header"
                    },
                    columns: [
                        {
                            field: "AttemptRes",
                            title: "Attempt",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('AttemptRes')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Attempt</span>",
                        },
                        {
                            field: "NRRes",
                            title: "NR",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('NRRes')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>NR</span>",
                        },
                        {
                            field: "DoneRes",
                            title: "Done",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('DoneRes')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Done</span>",
                        }
                    ]
                },
                {
                    title: "Office",
                    width: $mdMedia('gt-sm') ? '30%' : '150px',
                    headerAttributes: {
                        "class": "merge-grid-header"
                    },
                    columns: [
                        {
                            field: "AttemptOff",
                            title: "Attempt",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('AttemptOff')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Attempt</span>",
                        },
                        {
                            field: "NROff",
                            title: "NR",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('NROff')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>NR</span>",
                        },
                        {
                            field: "DoneOff",
                            title: "Done",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('DoneOff')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Done</span>",
                        }
                    ]
                },
                {
                    title: "Reference 1",
                    width: $mdMedia('gt-sm') ? '30%' : '150px',
                    headerAttributes: {
                        "class": "merge-grid-header"
                    },
                    columns: [
                        {
                            field: "AttemptRef1",
                            title: "Attempt",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('AttemptRef1')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Attempt</span>",
                        },
                        {
                            field: "NRRef1",
                            title: "NR",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('NRRef1')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>NR</span>",
                        },
                        {
                            field: "DoneRef1",
                            title: "Done",
                            type: "text",
                            scrollable: false,
                            search: true,
                            template:"<span >{{dataItem[CallingReportCtrl.formatColumnName('DoneRef1')]}}</span>",
                            headerTemplate: "<span class='grid-header-span'>Done</span>",
                        }
                    ]
                },
                {
                    title: "Reference 2",
                    width: $mdMedia('gt-sm') ? '30%' : '150px',
                    headerAttributes: {
                        "class": "merge-grid-header"
                    },
                    columns: [
                        {
                            field: "AttemptRef2",
                            title: "Attempt",
                            type: "text",
                            scrollable: false,
                            search: true,
                            headerTemplate: "<span class='grid-header-span'>Attempt</span>",
                        },
                        {
                            field: "NRRef2",
                            title: "NR",
                            type: "text",
                            scrollable: false,
                            search: true,
                            headerTemplate: "<span class='grid-header-span'>NR</span>",
                        },
                        {
                            field: "DoneRef2",
                            title: "Done",
                            type: "text",
                            scrollable: false,
                            search: true,
                            headerTemplate: "<span class='grid-header-span'>Done</span>",
                        }
                    ]
                },
                
            ];


            return Report;

        }]);
})();